export const rtcRequestEventPublish = event => ({
	type: 'RTC_REQUEST_PUBLISH',
	event
});